import { render, staticRenderFns } from "./DatabaseSelectionDialog.vue?vue&type=template&id=1f118025&"
import script from "./DatabaseSelectionDialog.vue?vue&type=script&lang=ts&"
export * from "./DatabaseSelectionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports